import MessageBubble from './MessageBubble';
import type { Message } from '../types';

interface MessageListProps {
  messages: Message[];
  isLoading: boolean;
}

export default function MessageList({ messages, isLoading }: MessageListProps) {
  if (messages.length === 0 && !isLoading) {
    return (
      <div className="flex items-center justify-center h-full text-gray-500">
        <p className="text-[15px] font-light">Start a conversation by sending a message below</p>
      </div>
    );
  }

  return (
    <>
      {messages.map((message, index) => {
        // Show loading state on the last assistant message when isLoading is true
        const isLastAssistantMessage =
          isLoading &&
          index === messages.length - 1 &&
          message.role === 'assistant';

        return (
          <div className="mb-4 md:mb-8" key={message.id}>
            <MessageBubble
              message={message}
              isLoading={isLastAssistantMessage}
            />
          </div>
        );
      })}
    </>
  );
}
